export const revisionStatusClassNames = {
    draft: 'neutral',
    in_review: 'positive',
    completed: 'active'
}

export const revisionStatusLabels = {
    draft: {
        id: 'salary_revision_status_draft',
        defaultMessage: 'Draft'
    },
    in_review: {
        id: 'salary_revision_status_in_review',
        defaultMessage: 'In review'
    },
    completed: {
        id: 'salary_revision_status_completed',
        defaultMessage: 'Completed'
    }
}

export const revisionGroupStatusClassNames = {
    draft: 'neutral',
    pending: 'neutral',
    submitted: 'positive',
    approved: 'active'
}

export const revisionGroupStatusLabels = {
    draft: {
        id: 'salary_revision_group_status_draft',
        defaultMessage: 'Draft'
    },
    pending: {
        id: 'salary_revision_group_status_pending',
        defaultMessage: 'Pending'
    },
    submitted: {
        id: 'salary_revision_group_status_submitted',
        defaultMessage: 'Submitted'
    },
    approved: {
        id: 'salary_revision_group_status_approved',
        defaultMessage: 'Approved'
    }
}

export const periodUnits = ['yearly', 'monthly', 'weekly', 'hourly']

export const defaultAmounts = {
    yearly: 0,
    monthly: 0,
    weekly: 0,
    hourly: 0
}

export const revisionHoursPerWeek = [
    37.5,
    40
]